module.exports = __webpack_public_path__ + "static/media/globalIcon.7477c7fc.svg";